import { FC, memo, useMemo } from "react"

import SidePanel from "../side-panel"
import If from "../if"
import SafeHTMLRenderer from "../safe-html-renderer"
import {
  useFetchPrintEmailQuery,
  useFetchSubscriptionEmailLogsQuery
} from "../../../redux/queries"
import { SubscriptionEmailStatsType } from "../../../types"

interface Props {
  open: boolean
  id?: string
  title?: string
  subscriptionId?: string
  eventType?: SubscriptionEmailStatsType
  noDataText?: string
  onClose: () => void
}

const EmailViewerModal: FC<Props> = memo(
  ({
    open,
    id,
    title = "Rate alert email",
    subscriptionId,
    eventType = SubscriptionEmailStatsType.INTRO,
    noDataText = "No rate alert email found.",
    onClose
  }) => {
    const { data: emailLogs, isFetching: isFetchingEmailLogs } =
      useFetchSubscriptionEmailLogsQuery(
        { id: subscriptionId!, type: eventType },
        { skip: !subscriptionId }
      )

    const emailId = useMemo(() => {
      if (subscriptionId && !isFetchingEmailLogs)
        return emailLogs?.[0]?.email_id
      return id
    }, [subscriptionId, isFetchingEmailLogs, emailLogs, id])

    const { data: emailHtml, isFetching: isFetchingEmailHtml } =
      useFetchPrintEmailQuery({ id: emailId! }, { skip: !emailId })

    return (
      <SidePanel open={open} title={title} onClose={onClose}>
        <div className="h-full flex flex-col">
          <div className="bg-white">
            <If
              isLoading={isFetchingEmailLogs || isFetchingEmailHtml}
              condition={!!emailHtml && emailHtml !== "Unauthorized"}
              then={
                <SafeHTMLRenderer htmlContent={emailHtml!} isText={false} />
              }
              else={<div className="pt-6">{noDataText}</div>}
              loaderClassName="pt-6"
            />
          </div>
        </div>
      </SidePanel>
    )
  }
)

export default EmailViewerModal
